import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main-links" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link, index) => {
      return (_openBlock(), _createElementBlock("a", {
        key: index,
        href: link.url,
        target: "_blank",
        class: "main-links-item"
      }, [
        _createElementVNode("span", {
          class: "main-links-item-icon",
          style: _normalizeStyle(`mask: url(data:image/svg+xml;base64,${link.icon}) no-repeat center; mask-size: contain;`)
        }, null, 4),
        _createTextVNode(" " + _toDisplayString(link.name), 1)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}